document.addEventListener( 'DOMContentLoaded', function() {
  if (!document.querySelector('#slider-buttons__slider').classList.contains('is-splide')) {
    const sliderButtons = new Splide('#slider-buttons__slider', {
      type: 'fade',
      perPage: 1,
      autoplay: true,
      rewind: true,
      pagination: false,
      arrows: false,
      drag: false,
    });
    sliderButtons.mount();

    const buttons = document.querySelectorAll(".slider-buttons__btn");

    if (buttons.length > 0) {
      buttons[0].classList.add("is-active");
    }

    document.querySelectorAll(".slider-buttons__btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        let index = parseInt(btn.getAttribute("data-index"), 10);
        sliderButtons.go(index);
      });
    });

    sliderButtons.on("move", (newIndex) => {
      document.querySelectorAll(".slider-buttons__btn").forEach((btn, i) => {
        btn.classList.toggle("is-active", i === newIndex);
      });
    });
  }
});
